<div class="col-md-6 ms-3 me-3" style="margin-top:10px;">
  <div class="col-md-12 border" style="border-radius:10px;">
    <img src='../../../../assets/oddfellow_logga.PNG' style="margin-top:25px;" title="Odd Fellow medlemsregister" (click)="home()" />
    
    <div class="col-md-12 mt-3" style="border-top: 1px solid #F0F0F0;border-bottom:1px solid #F0F0F0;padding-top:10px;padding-bottom:10px;">
      <div class="p-2">
        Ditt konto har låsts pga för många misslyckade inloggningsförsök. Kontot blir upplåst om 30 minuter så försök igen senare!
        <br />
        Om du har glömt ditt lösenord kan det återställas <a href="#" (click)="resetpassword(); $event.preventDefault();">här</a>.
      </div>
    </div>
    <br>
  </div>
</div>
